import axios from "axios";

export * from "./routes.constants";

// Previously hardcoded to https://wms-backend-j9oz.onrender.com/api/v1
// Use REACT_APP_API_BASE_URL at build time to target any environment.
export const baseURL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4004/api/v1";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
});

const addTokenToRequest = async (req) => {
  const token = localStorage.getItem("WMS#221#");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
};

axiosInstance.interceptors.request.use(addTokenToRequest);

export default axiosInstance;
